/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ILabel } from './Label';
import type { IPromoProp } from '../promo_search_result/PromoProp';
import type { IPromoPopup } from './PromoPopup';

export interface IPromoDesktop {
  /** Метки **/
  labels: ILabel[];
  /** Пары (заголовок, значение) для свойств акции (Ставка, сумма кредита и т.д.) **/
  promoProps: IPromoProp[];
  /** IDs ЖК **/
  newbuildingIds: number[];
  /** id акции на стороне провайдера(может повторяться) **/
  providerPromoId: number;
  /** Id автора акции **/
  providerId?: TPromoDesktop_ProviderId;
  /** Название автора акции (банка, застройщика и др) **/
  providerName: string;
  /** Название акции **/
  promoName: string;
  /** Тип акции **/
  promoType: EPromoType;
  /** Уникальный id акции (состоит из полей: bank_id, builder_id, provider_promo_id, promo_type) **/
  uniquePromoId: string;
  /** Лого банка или застройщика **/
  providerLogo: string;
  promoPopup: IPromoPopup;
}

export type TPromoDesktop_ProviderId = null | number;

export enum EPromoType {
  /** Скидки **/
  Discount = 'discount',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Бонусы **/
  Bonus = 'bonus',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Военная ипотека **/
  Military = 'military',
  /** Циан ипотека **/
  CianMortgage = 'cianMortgage',
  /** Рассрочка **/
  Installment = 'installment',
}
